import React from 'react';
import cs from 'classnames';
import { Card, CardContent, Typography } from '@forgeglobal/design-framework';
import { useStyles } from './style';

interface InfoCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

const InfoCard = ({
  title,
  children,
  className,
  contentClassName,
}: InfoCardProps) => {
  const classes = useStyles();
  return (
    <Card className={cs(classes.card, className)}>
      <CardContent
        surface="light"
        className={cs(classes.cardContent, contentClassName)}>
        <Typography
          variant="overline"
          color="textSecondary"
          component="div"
          className={classes.title}>
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
};

export default InfoCard;
